<template>
  <v-overlay
    :model-value="true"
    :scrim="false"
    persistent
    scroll-strategy="none"
    no-click-animation
    width="400"
    :content-props="{ style: { top: '5rem', right: '1rem' } }">
    <package-progress
      v-show="dialogs.packageProgress.isOpen"
      class="mb-3"></package-progress>
    <prod-alert v-show="dialogs.prodAlert.isOpen" class="mb-3"></prod-alert>
    <system-info-alert
      v-show="dialogs.systemInfoAlert.isOpen"
      class="mb-3"></system-info-alert>
  </v-overlay>
</template>

<script lang="ts">
import { usePermanentDialog } from '@/store/permanentDialog'
import PackageProgress from './components/package-progress/Index.vue'
import ProdAlert from './components/ProdAlert.vue'
import SystemInfoAlert from './components/SystemInfoAlert.vue'

export default {
  name: 'PackageProgressDialog',
  components: { SystemInfoAlert, PackageProgress, ProdAlert },
  setup() {
    const { dialogs } = usePermanentDialog()

    return {
      dialogs,
    }
  },
}
</script>

<style scoped lang="scss"></style>
